export const UserActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_USER_ACCOUNTS: 'SET_USER_ACCOUNTS',
  SET_CURRENT_SUBSCRIPTIONS: 'SET_CURRENT_SUBSCRIPTIONS',
  SET_ACTIVE_DEVICES: 'SET_ACTIVE_DEVICES',
  SIGN_OUT_USER: 'SIGN_OUT_USER',
};
